import React, { Component } from 'react';
import { Row, Col, Button, Input } from "reactstrap";
import { api } from "../helpers";
import './Site.css';

export default class EmailTest extends Component {
    static displayName = EmailTest.name;
    constructor(props) {
        super(props);
        this.state = {
            attemptedEmailSend: false,
            success: false,
            message: "",
            email: ""
        }
        this.sendEmail = this.sendEmail.bind(this);
        this.showResults = this.showResults.bind(this);
    }

    showResults(success, message){
        this.setState({
            attemptedEmailSend: true,
            success: success,
            message: message
        });
    }
    
    sendEmail() {
        api.post('Admin/SendTestEmail', JSON.stringify(this.state.email))
            .then(response => {
                if (response && response.data) {
                    if (response.data.success) {
                        this.showResults(true, "");
                    } else {
                        this.showResults(false, response.data.message);
                    }
                }
            })
            .catch(error =>
                this.showResults(false, "There was an error attempting to send the email")
            );
    }
    
    render() {
        return (
            <div>
            <Row>
                <Col>
                    <Input value={this.state.email} onChange={(e) => this.setState({
                        email: e.target.value
                    })} />
                </Col>
                <Col>
                    <Button onClick={() => this.sendEmail()}>Send Test Email</Button>
                </Col>
            </Row>
                <Row>
                    <Col>
                        {this.state.attemptedEmailSend && this.state.success && (
                            <p>Email was sent successfully</p>
                            )}
                        {this.state.attemptedEmailSend && !this.state.success && (
                                <pre>Email send failed - {this.state.message}</pre>
                            )}
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EmailTest.js